import React from 'react'

import { InnosErrorBoundary } from '@inno-tools/container-bridge'
import { FeedbackApp } from 'modules/app-registry/components'

import styles from './QuickActions.module.scss'

interface QuickActionsProps {
  children?: React.ReactNode
}

export const QuickActions = ({ children }: QuickActionsProps) => {
  return (
    <div className={styles.quickActions}>
      <InnosErrorBoundary debugName='FeedbackApp'>
        <FeedbackApp />
      </InnosErrorBoundary>
      {children}
    </div>
  )
}
